import Vue from 'vue'
import Vuex from 'vuex'
import { TOKEN_KEY } from '../utils/constants'

Vue.use(Vuex)
const getLocalUserInfo = () => {
  const userInfo = JSON.parse(localStorage.getItem(TOKEN_KEY)) || {}
  return userInfo
}

export default new Vuex.Store({
  state: {
    userInfo: getLocalUserInfo()
  },
  mutations: {
    // 设置用户信息
    SET_USERINFO (state, info) {
      localStorage.setItem(TOKEN_KEY, JSON.stringify(info))
      state.userInfo = info
    },
    LOG_OUT (state) {
      localStorage.removeItem(TOKEN_KEY)
      state.userInfo = {}
    }
  },
  actions: {
  },
  modules: {
  }
})
